<template>
  <div class="min-h-screen bg-app-bg-light dark:bg-app-bg-dark antialiased font-sans">
    <!-- Toast Notification -->
    <transition name="toast">
      <div
        v-if="mostrarToast"
        class="fixed top-6 right-6 z-50 max-w-sm"
      >
        <div
          class="rounded-2xl shadow-2xl backdrop-blur-md p-4 flex items-center gap-3 border"
          :class="alerta.tipo === 'success'
            ? 'bg-emerald-50/95 dark:bg-emerald-900/95 border-emerald-200 dark:border-emerald-700'
            : 'bg-rose-50/95 dark:bg-rose-900/95 border-rose-200 dark:border-rose-700'"
        >
          <div
            class="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center"
            :class="alerta.tipo === 'success' ? 'bg-emerald-500' : 'bg-rose-500'"
          >
            <i
              :class="alerta.tipo === 'success' ? 'bx bx-check' : 'bx bx-x'"
              class="text-white text-2xl"
            ></i>
          </div>
          <p
            class="flex-1 font-medium text-sm"
            :class="alerta.tipo === 'success'
              ? 'text-emerald-900 dark:text-emerald-100'
              : 'text-rose-900 dark:text-rose-100'"
          >
            {{ alerta.mensaje }}
          </p>
          <button
            @click="cerrarToast"
            class="flex-shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
          >
            <i class="bx bx-x text-xl"></i>
          </button>
        </div>
      </div>
    </transition>

    <!-- Header -->
    <div class="bg-white dark:bg-slate-800 border-b border-slate-200/50 dark:border-slate-700/50 sticky top-0 z-40 shadow-sm backdrop-blur-sm bg-white/95 dark:bg-slate-800/95">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2">
        <div class="flex items-center justify-between gap-4">
          <!-- Mesa Info -->
          <div class="flex items-center gap-3 justify-center">
            <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center shadow-lg">
              <i class="bx bx-dish text-white text-2xl"></i>
            </div>
            <div class="flex flex-col justify-start items-start">
              <p class="text-xs uppercase tracking-[0.15em] text-slate-500 dark:text-slate-400 font-semibold mb-0 mr-1">Mesa</p>
              <p class="text-2xl font-bold text-slate-900 dark:text-white mb-0">#{{ numeroMesa || '—' }}</p>
            </div>
          </div>

          <!-- Cuentas Pills -->
        <div v-if="pedidoAbierto" class="flex flex-wrap items-center gap-2 w-[570px]">
          <span class="text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-[0.15em]">Cuentas:</span>
          <div
            v-for="c in cuentas"
            :key="c.IdCuentaPedido"
            class="group inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 dark:bg-primary/20 border border-primary/30 dark:border-primary/40 hover:bg-primary/20 dark:hover:bg-primary/30 transition-all"
          >
            <span class="text-sm font-semibold text-slate-700 dark:text-slate-300">{{ c.NombreCuenta }}</span>
            <span class="text-xs font-bold text-primary">Q{{ c.Total }}</span>
            <button
              @click="abrirModalAsignarHabitacion(c)"
              :class="c.IdReservaHabitacion ? 'bg-emerald-500/90 hover:bg-emerald-600' : 'bg-blue-500/80 hover:bg-blue-600'"
              class="ml-1 rounded-full flex items-center justify-center text-white transition-all border-0"
              style="width: 24px !important; height: 24px !important; min-width: 24px !important; min-height: 24px !important; max-width: 24px !important; max-height: 24px !important; padding: 0 !important;"
              :title="c.IdReservaHabitacion ? 'Cambiar habitación' : 'Asignar a habitación'"
            >
              <i :class="c.IdReservaHabitacion ? 'bx bx-check' : 'bx bx-home-circle'" class="text-base"></i>
            </button>
            <button
              @click="confirmarEliminarCuenta(c)"
              class="ml-1 rounded-full flex items-center justify-center bg-rose-500/80 hover:bg-rose-600 text-white transition-all border-0"
              style="width: 24px !important; height: 24px !important; min-width: 24px !important; min-height: 24px !important; max-width: 24px !important; max-height: 24px !important; padding: 0 !important;"
            >
              <i class="bx bx-x text-lg"></i>
            </button>
          </div>
          <button
            @click="abrirModalAgregarCuenta"
            class="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border-2 border-dashed border-slate-300 dark:border-slate-600 text-slate-600 dark:text-slate-400 hover:border-primary hover:text-primary hover:bg-primary/5 transition-all"
          >
            <i class="bx bx-plus text-lg"></i>
            <span class="text-sm font-semibold">Agregar</span>
          </button>
          <router-link
            v-if="idPedido"
            :to="{ name: 'CuentasPedidoDetalles', params: { idPedido: idPedido } }"
            class="ml-0 px-4 py-2 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors text-sm font-semibold flex items-center gap-1"
          >
            <i class="bx bx-receipt"></i>
            <span>Ver detalles</span>
          </router-link>
          <button
            v-if="idPedido && cuentas.length > 1"
            @click="abrirModalReasignar"
            class="px-4 py-2 rounded-full bg-blue-100 dark:bg-blue-900/50 text-blue-700 dark:text-blue-300 hover:bg-blue-200 dark:hover:bg-blue-900 transition-colors text-sm font-semibold flex items-center gap-1"
          >
            <i class="bx bx-transfer"></i>
            <span>Mover platillos</span>
          </button>
        </div>

          <!-- Pedido Status -->
          <div class="flex items-center gap-2">
            <button
              v-if="!pedidoAbierto"
              @click="abrirModalAbrirPedido"
              :disabled="cargandoPedido"
              class="px-6 py-3 bg-gradient-to-r from-teal-600/90 to-emerald-600/90 hover:from-teal-700 hover:to-emerald-700 text-white font-semibold rounded-full border-0 shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <i class="bx bx-folder-open text-xl"></i>
              <span>Abrir Pedido</span>
            </button>
            <button
              v-else
              @click="abrirModalCerrarPedido"
              class="px-6 py-3 bg-gradient-to-r from-rose-500/85 to-rose-600/85 hover:from-rose-600/95 hover:to-rose-700/95 text-white font-semibold rounded-full border-0 shadow-lg hover:shadow-xl transition-all duration-200 flex items-center gap-2"
            >
              <i class="bx bx-lock text-xl"></i>
              <span>Cerrar Pedido</span>
            </button>
          </div>
        </div>


      </div>
    </div>

    <!-- Main Content Grid -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">

        <!-- Menú Section (Left - 2 columns) -->
        <div class="lg:col-span-2 space-y-6">
          <!-- Menu Card -->
          <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-lg border border-slate-200 dark:border-slate-700 overflow-hidden">
            <!-- Menu Header -->
            <div class="px-6 py-4 bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-700 border-b border-slate-200 dark:border-slate-600">
              <div class="flex items-center justify-between">
                <h3 class="text-xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
                  <i class="bx bx-food-menu text-primary text-2xl"></i>
                  Menú
                </h3>
              </div>
            </div>

            <div v-if="pedidoAbierto" class="p-6 space-y-4">
              <!-- Search Bar -->
              <div class="relative">
                <i class="bx bx-search absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 text-xl"></i>
                <input
                  type="text"
                  v-model="busqueda"
                  placeholder="Buscar platillo..."
                  class="w-full pl-12 pr-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none transition-all text-slate-900 dark:text-white"
                />
              </div>

              <!-- Categories -->
              <div class="flex flex-wrap gap-3">
                <button
                  v-for="cat in menu"
                  :key="cat.IdCategoria"
                  @click="toggleCategoria(cat)"
                  class="px-5 py-2.5 rounded-xl font-semibold transition-all duration-300 border"
                  :class="categoriaActiva?.IdCategoria === cat.IdCategoria
                    ? 'bg-gradient-to-r from-primary to-secondary text-white shadow-lg border-transparent transform scale-105'
                    : 'bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:border-primary hover:text-primary hover:shadow-md'"
                >
                  {{ cat.Categoria }}
                </button>
              </div>

              <!-- Platillos Grid -->
              <div v-if="categoriaActiva || (busqueda && busqueda.trim())" class="space-y-3" ref="platillosGrid">
                <h4 v-if="!busqueda || !busqueda.trim()" class="text-lg font-bold px-4 py-2 bg-gradient-to-r from-slate-800 to-slate-900 dark:from-slate-700 dark:to-slate-600 text-white rounded-xl shadow-md">
                  {{ categoriaActiva.Categoria }}
                </h4>
                <h4 v-else class="text-lg font-bold px-4 py-2 bg-gradient-to-r from-primary to-secondary text-white rounded-xl shadow-md">
                  <i class="bx bx-search-alt mr-2"></i>Resultados de búsqueda ({{ platillosFiltrados.length }})
                </h4>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[600px] overflow-y-auto pr-2">
                  <div
                    v-for="platillo in platillosFiltrados"
                    :key="platillo.IdPlatillo"
                    class="bg-white dark:bg-slate-800 rounded-2xl p-4 border border-slate-200 dark:border-slate-700 hover:shadow-xl hover:border-primary/50 transition-all duration-300 group cursor-pointer"
                    @click="abrirModal(platillo)"
                  >
                    <div class="flex justify-between items-start gap-3">
                      <div class="flex-1">
                        <h5 class="font-bold text-slate-900 dark:text-white mb-1 group-hover:text-primary transition-colors">
                          {{ platillo.Nombre }}
                        </h5>
                        <p class="text-sm text-slate-600 dark:text-slate-400 line-clamp-2">
                          {{ platillo.Descripcion }}
                        </p>
                      </div>
                      <div class="flex flex-col items-end gap-2 flex-shrink-0">
                        <span class="px-3 py-1.5 bg-gradient-to-r from-primary to-secondary text-white font-bold rounded-full text-sm shadow-md">
                          Q{{ platillo.Precio }}
                        </span>
                        <button
                          @click.stop="abrirModal(platillo)"
                          class="rounded-full bg-gradient-to-br from-teal-600/80 to-emerald-600/80 hover:from-teal-700/90 hover:to-emerald-700/90 text-white flex items-center justify-center transition-all shadow-md hover:shadow-lg border-none outline-none"
                          style="width: 32px !important; height: 32px !important; min-width: 32px !important; min-height: 32px !important; max-width: 32px !important; max-height: 32px !important; padding: 0 !important;"
                        >
                          <i class="bx bx-plus text-lg"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="p-12 text-center">
              <div class="inline-flex items-center justify-center w-20 h-20 rounded-full bg-yellow-100 dark:bg-yellow-900/30 mb-4">
                <i class="bx bx-lock-alt text-yellow-600 dark:text-yellow-400 text-4xl"></i>
              </div>
              <p class="text-slate-600 dark:text-slate-400 font-medium">
                Abre un pedido para ver el menú
              </p>
            </div>
          </div>

          <!-- Pedido Anterior/Actual -->
          <div v-if="pedidoAnterior.length" class="bg-white dark:bg-slate-800 rounded-2xl shadow-lg border border-slate-200 dark:border-slate-700 overflow-hidden">
            <div class="px-6 py-4 bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 border-b border-blue-200 dark:border-blue-700">
              <h3 class="text-lg font-bold text-slate-900 dark:text-white flex items-center gap-2">
                <i class="bx bx-receipt text-blue-600 dark:text-blue-400 text-2xl"></i>
                Pedido en Mesa
              </h3>
            </div>
            <div class="p-4 space-y-3 max-h-96 overflow-y-auto">
              <div
                v-for="(item, i) in pedidoAnterior"
                :key="i"
                class="bg-slate-50 dark:bg-slate-900 rounded-xl p-4 border border-slate-200 dark:border-slate-700"
              >
                <div class="flex justify-between items-start gap-4">
                  <div class="flex-1 space-y-2">
                    <div>
                      <h5 class="font-bold text-slate-900 dark:text-white">{{ item.platillo }}</h5>
                      <p class="text-sm text-slate-600 dark:text-slate-400">Precio base: Q{{ item.precio_platillo }}</p>
                    </div>

                    <!-- Action Buttons -->
                    <div class="flex items-center gap-2">
                      <button
                        v-if="puedeEmpacar(item)"
                        @click="abrirModalEmpacar(item)"
                        class="px-3 py-1.5 rounded-lg bg-yellow-500 hover:bg-yellow-600 text-white text-sm font-medium transition-colors flex items-center gap-1"
                      >
                        <i class="bx bx-package"></i>
                        <span>Empacar</span>
                      </button>
                      <span v-else class="px-3 py-1.5 rounded-lg bg-slate-200 dark:bg-slate-700 text-slate-600 dark:text-slate-400 text-sm font-medium">
                        {{ item.cantidad_empacada }}/{{ item.cantidad }} empacado
                      </span>

                      <button
                        v-if="puedeCancelar(item) || esEntregado(item)"
                        @click="abrirModalCancelar(item)"
                        class="px-3 py-1.5 rounded-full bg-gradient-to-r from-rose-600 to-rose-700 hover:from-rose-700 hover:to-rose-800 text-white text-sm font-medium transition-all shadow-md hover:shadow-lg flex items-center gap-1"
                      >
                        <i class="bx bx-x"></i>
                        <span>Cancelar</span>
                      </button>
                    </div>

                    <!-- Ingredients -->
                    <div v-if="item.ingredientes_no_quiere.length" class="flex flex-wrap gap-1">
                      <span
                        v-for="ing in item.ingredientes_no_quiere"
                        :key="ing"
                        class="px-2 py-1 rounded-full bg-rose-100 dark:bg-rose-900/30 text-rose-700 dark:text-rose-400 text-xs font-medium"
                      >
                        Sin {{ ing }}
                      </span>
                    </div>

                    <!-- Options -->
                    <div v-if="item.grupos.length" class="flex flex-wrap gap-1">
                      <span
                        v-for="g in item.grupos"
                        :key="g.opcion"
                        class="px-2 py-1 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 text-xs font-medium"
                      >
                        {{ g.opcion }}
                        <span v-if="g.precio_extra > 0"> (+Q{{ g.precio_extra }}) x{{ g.cantidad }}</span>
                      </span>
                    </div>

                    <!-- Status Badge -->
                    <div>
                      <span
                        v-if="estadoVisual(item) === 'cancelado'"
                        class="px-3 py-1 rounded-full bg-rose-100 dark:bg-rose-900/30 text-rose-700 dark:text-rose-400 text-xs font-bold uppercase tracking-wider"
                      >
                        Cancelado
                      </span>
                      <span
                        v-else-if="estadoVisual(item) === 'entregado'"
                        class="px-3 py-1 rounded-full bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-400 text-xs font-bold uppercase tracking-wider"
                      >
                        Entregado
                      </span>
                      <span
                        v-else
                        class="px-3 py-1 rounded-full bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 text-xs font-bold uppercase"
                      >
                        Pendiente
                      </span>
                    </div>
                  </div>

                  <!-- Total -->
                  <div class="flex-shrink-0">
                    <div class="px-4 py-2 rounded-xl bg-gradient-to-br from-emerald-600 to-emerald-700 text-white font-bold text-lg shadow-lg">
                      Q{{ Number(item.total_detalle).toFixed(2) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700">
              <div class="flex justify-between items-center">
                <span class="text-slate-600 dark:text-slate-400 font-medium">Total en mesa:</span>
                <span class="text-2xl font-bold text-slate-900 dark:text-white">Q{{ totalAnterior.toFixed(2) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Carrito Section (Right - 1 column) -->
        <div class="lg:col-span-1">
          <div class="sticky top-24 space-y-6">
            <!-- Carrito -->
            <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-lg border border-slate-200 dark:border-slate-700 overflow-hidden">
              <div class="px-6 py-4 bg-gradient-to-r from-emerald-50 to-emerald-100 dark:from-emerald-900/30 dark:to-emerald-800/30 border-b border-emerald-200 dark:border-emerald-700">
                <h3 class="text-lg font-bold text-slate-900 dark:text-white flex items-center gap-2">
                  <i class="bx bx-cart text-emerald-600 dark:text-emerald-400 text-2xl"></i>
                  Nuevo Pedido
                </h3>
              </div>

              <div v-if="pedido.length === 0" class="p-8 text-center">
                <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-100 dark:bg-slate-700 mb-3">
                  <i class="bx bx-cart text-slate-400 text-3xl"></i>
                </div>
                <p class="text-slate-500 dark:text-slate-400 text-sm">
                  No hay platillos agregados
                </p>
              </div>

              <div v-else class="p-4 max-h-[230px] h-[230px] overflow-y-auto nuevo-pedido-scroll">
                <!-- Tabla de productos -->
                <div class="space-y-2">
                  <div
                    v-for="(item, index) in pedido"
                    :key="item._uid"
                    class="bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden hover:shadow-lg transition-all duration-300"
                  >
                    <!-- Header Row con Nombre y Precio -->
                    <div class="bg-white dark:bg-slate-800/50 px-4 py-3 border-b border-slate-200 dark:border-slate-700">
                      <div class="flex items-center justify-between gap-3">
                        <div class="flex-1 min-w-0">
                          <h5 class="font-bold text-slate-900 dark:text-white truncate text-lg">
                            {{ item.Nombre }}
                          </h5>
                          <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                            Base: Q{{ parseFloat(item.Precio).toFixed(2) }}
                          </p>
                        </div>
                        <button
                          @click="eliminarDelPedido(index)"
                          class="flex items-center justify-center rounded-full bg-rose-50 dark:bg-rose-900/20 hover:bg-rose-400/80 hover:text-white text-rose-500/80 dark:text-rose-400/80 transition-all border-0 shadow-sm hover:shadow-md"
                          style="width: 32px !important; height: 32px !important; min-width: 32px !important; min-height: 32px !important; max-width: 32px !important; max-height: 32px !important; padding: 0 !important;"
                        >
                          <i class="bx bx-trash text-base"></i>
                        </button>
                      </div>
                    </div>

                    <!-- Body con detalles -->
                    <div class="px-4 py-3 space-y-3">
                      <!-- Ingredientes quitados -->
                      <div v-if="item.config.ingredientes.some(i => i.quitar === 1)" class="flex flex-wrap gap-1.5">
                        <span class="text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase">Sin:</span>
                        <span
                          v-for="ing in item.config.ingredientes.filter(i => i.quitar === 1)"
                          :key="ing.id_producto"
                          class="px-2 py-1 rounded-full bg-rose-100 dark:bg-rose-900/30 text-rose-700 dark:text-rose-400 text-xs font-medium"
                        >
                          {{ ing.nombre }}
                        </span>
                      </div>

                      <!-- Opciones -->
                      <div v-if="getOpcionesList(item.config.opciones).length" class="flex flex-wrap gap-1.5">
                        <span class="text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase">Con:</span>
                        <span
                          v-for="o in getOpcionesList(item.config.opciones)"
                          :key="o.IdGrupoOpcion + '-' + o.IdOpcion"
                          class="px-2 py-1 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 text-xs font-medium"
                        >
                          {{ o.opcion?.Nombre || 'Extra' }}
                          <span v-if="parseFloat(o.PrecioExtra) > 0">
                            (+Q{{ o.PrecioExtra }})<span v-if="(o.cantidad || 1) > 1">×{{ o.cantidad || 1 }}</span>
                          </span>
                        </span>
                      </div>

                      <!-- Cuenta Selector -->
                      <div class="bg-white dark:bg-slate-800 rounded-xl p-3 border border-slate-200 dark:border-slate-700">
                        <label class="block text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider mb-2">
                          <i class="bx bx-user text-primary mr-1"></i>Cuenta
                        </label>
                        <select
                          v-model="item.id_cuenta_pedido"
                          class="w-full px-3 py-2.5 rounded-lg bg-slate-50 dark:bg-slate-900 border-2 border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-primary outline-none text-sm font-medium transition-all"
                          required
                        >
                          <option disabled :value="null">-- Seleccionar --</option>
                          <option v-for="c in cuentas" :key="c.IdCuentaPedido" :value="c.IdCuentaPedido">
                            {{ c.NombreCuenta }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Footer con cantidad y subtotal -->
                    <div class="bg-gradient-to-r from-slate-50 to-slate-100 dark:from-slate-800/50 dark:to-slate-700/50 px-4 py-3 border-t border-slate-200/60 dark:border-slate-700/60">
                      <div class="space-y-3">
                        <!-- Cantidad -->
                        <div class="flex items-center justify-center gap-2">
                          <span class="text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wide">Cantidad:</span>
                          <button
                            @click="disminuirCantidad(index)"
                            class="flex items-center justify-center rounded-full bg-slate-200/80 dark:bg-slate-700/60 hover:bg-slate-300/90 dark:hover:bg-slate-600/80 text-slate-600 dark:text-slate-300 transition-all border-0 shadow-sm hover:shadow-md"
                            style="width: 32px !important; height: 32px !important; min-width: 32px !important; min-height: 32px !important; max-width: 32px !important; max-height: 32px !important; padding: 0 !important;"
                          >
                            <i class="bx bx-minus text-sm"></i>
                          </button>
                          <span class="w-10 text-center font-bold text-lg text-slate-900 dark:text-white">{{ item.cantidad }}</span>
                          <button
                            @click="aumentarCantidad(index)"
                            class="flex items-center justify-center rounded-full bg-gradient-to-br from-teal-600/80 to-emerald-600/80 hover:from-teal-700/90 hover:to-emerald-700/90 text-white transition-all border-0 shadow-sm hover:shadow-md"
                            style="width: 32px !important; height: 32px !important; min-width: 32px !important; min-height: 32px !important; max-width: 32px !important; max-height: 32px !important; padding: 0 !important;"
                          >
                            <i class="bx bx-plus text-sm"></i>
                          </button>
                        </div>

                        <!-- Subtotal -->
                        <div class="text-center">
                          <div class="text-xs text-slate-500 dark:text-slate-400 uppercase font-semibold mb-1">Subtotal</div>
                          <div class="text-xl font-bold text-teal-700/90 dark:text-teal-500/90">
                            Q{{ subtotalItem(item).toFixed(2) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Footer con Total y Enviar -->
              <div v-if="pedido.length" class="px-6 py-4 bg-gradient-to-br from-slate-50/90 to-slate-100/80 dark:from-slate-900/50 dark:to-slate-800/50 border-t border-slate-200/60 dark:border-slate-700/60 space-y-3">
                <div class="flex justify-between items-center">
                  <span class="text-slate-500 dark:text-slate-400 font-medium">Total:</span>
                  <span class="text-2xl font-bold text-slate-800 dark:text-slate-100">Q{{ totalPedido.toFixed(2) }}</span>
                </div>
                <button
                  @click="abrirConfirmacionEnvio"
                  class="w-full py-3.5 bg-gradient-to-r from-teal-600/90 to-emerald-600/90 hover:from-teal-700 hover:to-emerald-700 text-white font-bold rounded-full border-0 shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center gap-2"
                >
                  <i class="bx bx-send text-xl"></i>
                  <span>Enviar Pedido</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Floating Notes Button -->
    <button
      v-if="pedidoAbierto"
      @click="abrirModalNotas"
      class="fixed bottom-6 right-6 w-14 h-14 rounded-full bg-gradient-to-br from-primary to-secondary text-white shadow-2xl hover:scale-110 transition-transform duration-200 flex items-center justify-center z-40 border-0"
    >
      <i class="bx bx-note text-2xl"></i>
    </button>

    <!-- Modal Abrir Pedido -->
    <transition name="modal">
      <div v-if="showModalAbrirPedido" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="closeModalAbrirPedido">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white">Abrir Pedido</h3>
            <button @click="closeModalAbrirPedido" class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-400 transition-colors">
              <i class="bx bx-x text-2xl"></i>
            </button>
          </div>
          <div class="p-6 space-y-4">
            <div>
              <label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2">Número de cuentas</label>
              <input
                type="number"
                min="1"
                v-model.number="numCuentas"
                class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
              />
            </div>
            <div v-for="(c, i) in cuentasTemp" :key="i" class="space-y-1">
              <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 uppercase tracking-wider">Cuenta {{ i + 1 }}</label>
              <input
                type="text"
                v-model="c.nombre_cuenta"
                :placeholder="`Cuenta ${i+1}`"
                class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
              />
            </div>

            <!-- Opción para cargar a habitación -->
            <div class="border-t border-slate-200 dark:border-slate-700 pt-4">
              <label class="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  v-model="cargarAHabitacion"
                  class="w-4 h-4 text-primary border-slate-300 rounded focus:ring-primary"
                />
                <span class="text-sm font-semibold text-slate-700 dark:text-slate-300">Cargar a habitación</span>
              </label>

              <div v-if="cargarAHabitacion" class="mt-3">
                <label class="block text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">Buscar habitación (número, huésped o código):</label>
                <input
                  type="text"
                  v-model="busquedaHabitacion"
                  @input="filtrarHabitacionesPedido"
                  placeholder="Ej: 101, Juan Pérez, R00123"
                  class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none mb-3"
                />

                <div v-if="cargandoHabitaciones" class="text-sm text-slate-500 dark:text-slate-400 text-center py-3">
                  <i class="bx bx-loader-alt bx-spin"></i> Cargando habitaciones...
                </div>
                <div v-else-if="habitacionesFiltradas.length" class="max-h-48 overflow-y-auto space-y-2 border border-slate-200 dark:border-slate-700 rounded-xl p-2">
                  <div
                    v-for="hab in habitacionesFiltradas"
                    :key="hab.IdReservaHabitacion"
                    @click="habitacionSeleccionada = hab.IdReservaHabitacion"
                    class="p-3 rounded-lg border cursor-pointer transition-all"
                    :class="habitacionSeleccionada === hab.IdReservaHabitacion
                      ? 'bg-primary/10 border-primary border-2'
                      : 'bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-700'"
                  >
                    <div class="font-semibold text-slate-900 dark:text-white">Habitación {{ hab.Numero }}</div>
                    <div class="text-sm text-slate-600 dark:text-slate-400">{{ hab.huesped?.Nombre }} {{ hab.huesped?.Apellido }}</div>
                    <div class="text-xs text-slate-500 dark:text-slate-500">{{ hab.CodigoReserva }}</div>
                  </div>
                </div>
                <div v-else-if="busquedaHabitacion" class="text-sm text-slate-500 dark:text-slate-400 text-center py-3">
                  No se encontraron habitaciones con esa búsqueda
                </div>
                <div v-else-if="!cargandoHabitaciones && habitacionesDisponibles.length === 0" class="text-sm text-slate-500 dark:text-slate-400 text-center py-3">
                  No hay habitaciones ocupadas actualmente
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 flex gap-3">
            <button @click="closeModalAbrirPedido" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-700/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cancelar
            </button>
            <button @click="confirmarAbrirPedido" class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-primary/90 to-secondary/90 hover:from-primary hover:to-secondary text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal: Asignar Habitación a Cuenta -->
    <transition name="modal">
      <div v-if="showModalAsignarHabitacion" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="cerrarModalAsignarHabitacion">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white">🏠 Asignar a Habitación</h3>
            <button @click="cerrarModalAsignarHabitacion" class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-400 transition-colors">
              <i class="bx bx-x text-2xl"></i>
            </button>
          </div>
          <div class="p-6 space-y-4">
            <div class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-xl p-3">
              <p class="text-sm text-slate-700 dark:text-slate-300">
                <strong>Cuenta:</strong> {{ cuentaSeleccionadaHabitacion?.NombreCuenta }}<br>
                <strong>Total:</strong> Q{{ cuentaSeleccionadaHabitacion?.Total }}
              </p>
            </div>

            <div v-if="cuentaSeleccionadaHabitacion?.IdReservaHabitacion" class="bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-xl p-3">
              <p class="text-sm text-slate-700 dark:text-slate-300 mb-2">
                <i class="bx bx-info-circle"></i> Esta cuenta ya está asignada a una habitación
              </p>
              <button
                @click="desasignarHabitacion"
                class="w-full px-4 py-2 rounded-lg bg-rose-500/90 hover:bg-rose-600 text-white font-semibold transition-all"
              >
                <i class="bx bx-x-circle"></i> Quitar asignación
              </button>
              <div class="mt-2 text-center">
                <span class="text-xs text-slate-500 dark:text-slate-400">o selecciona otra habitación abajo</span>
              </div>
            </div>

            <div>
              <label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2">Buscar habitación:</label>
              <input
                type="text"
                v-model="busquedaHabitacionCuenta"
                @input="filtrarHabitacionesCuenta"
                placeholder="Ej: 101, Juan Pérez, R00123"
                class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
              />
            </div>

            <div v-if="cargandoHabitaciones" class="text-sm text-slate-500 dark:text-slate-400 text-center py-3">
              <i class="bx bx-loader-alt bx-spin"></i> Cargando habitaciones...
            </div>
            <div v-else-if="habitacionesFiltradasCuenta.length" class="max-h-64 overflow-y-auto space-y-2 border border-slate-200 dark:border-slate-700 rounded-xl p-2">
              <div
                v-for="hab in habitacionesFiltradasCuenta"
                :key="hab.IdReservaHabitacion"
                @click="seleccionarHabitacionParaCuenta(hab.IdReservaHabitacion)"
                class="p-3 rounded-lg border cursor-pointer transition-all"
                :class="habitacionSeleccionadaCuenta === hab.IdReservaHabitacion
                  ? 'bg-primary/10 border-primary border-2'
                  : 'bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-700'"
              >
                <div class="font-semibold text-slate-900 dark:text-white">Habitación {{ hab.Numero }}</div>
                <div class="text-sm text-slate-600 dark:text-slate-400">{{ hab.huesped?.Nombre }} {{ hab.huesped?.Apellido }}</div>
                <div class="text-xs text-slate-500 dark:text-slate-500">{{ hab.CodigoReserva }}</div>
              </div>
            </div>
            <div v-else-if="busquedaHabitacionCuenta" class="text-sm text-slate-500 dark:text-slate-400 text-center py-3">
              No se encontraron habitaciones con esa búsqueda
            </div>
            <div v-else-if="!cargandoHabitaciones && habitacionesDisponibles.length === 0" class="text-sm text-slate-500 dark:text-slate-400 text-center py-3">
              No hay habitaciones ocupadas actualmente
            </div>
          </div>
          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 flex gap-3">
            <button @click="cerrarModalAsignarHabitacion" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-700/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cancelar
            </button>
            <button
              @click="confirmarAsignarHabitacion"
              :disabled="!habitacionSeleccionadaCuenta"
              class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-primary/90 to-secondary/90 hover:from-primary hover:to-secondary text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <i class="bx bx-check"></i> Confirmar
            </button>
          </div>
        </div>
      </div>
    </transition>

<!-- Modal Confirmar Envío -->
    <transition name="modal">
      <div v-if="showModalConfirmEnvio" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="closeModalConfirmEnvio">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] flex flex-col">
          <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 flex items-center gap-3">
            <div class="w-10 h-10 rounded-full bg-teal-100 dark:bg-teal-900/40 flex items-center justify-center flex-shrink-0">
              <i class="bx bx-send text-teal-600 dark:text-teal-400 text-xl"></i>
            </div>
            <div>
              <h3 class="text-xl font-bold text-slate-900 dark:text-white">Confirmar envío</h3>
              <p class="text-sm text-slate-500 dark:text-slate-400">Repite el pedido al cliente antes de confirmar</p>
            </div>
          </div>

          <div class="p-6 overflow-y-auto flex-1 space-y-4">
            <!-- Resumen de ítems agrupados por cuenta -->
            <div>
              <p class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-2">Ítems a enviar</p>
              <div class="space-y-2">
                <div v-for="cuenta in cuentas" :key="cuenta.IdCuentaPedido">
                  <template v-if="pedido.some(p => p.id_cuenta_pedido === cuenta.IdCuentaPedido)">
                    <p class="text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1">
                      <i class="bx bx-user me-1"></i>{{ cuenta.NombreCuenta }}
                    </p>
                    <div class="flex flex-wrap gap-1.5">
                      <span
                        v-for="(item, idx) in pedido.filter(p => p.id_cuenta_pedido === cuenta.IdCuentaPedido)"
                        :key="idx"
                        class="inline-flex items-center gap-1 bg-teal-50 dark:bg-teal-900/30 border border-teal-200 dark:border-teal-700 text-teal-800 dark:text-teal-300 px-3 py-1 rounded-full text-sm font-medium"
                      >
                        <span v-if="item.cantidad > 1" class="font-bold">{{ item.cantidad }}×</span>
                        {{ item.Nombre }}
                        <span v-if="item.config.ingredientes.some(i => i.quitar === 1)" class="text-rose-500 dark:text-rose-400 text-xs ml-0.5">(sin extras)</span>
                      </span>
                    </div>
                  </template>
                </div>
                <!-- Items sin cuenta asignada -->
                <div v-if="pedido.some(p => !p.id_cuenta_pedido)">
                  <p class="text-xs font-semibold text-amber-600 dark:text-amber-400 mb-1">
                    <i class="bx bx-error-circle me-1"></i>Sin cuenta asignada
                  </p>
                  <div class="flex flex-wrap gap-1.5">
                    <span
                      v-for="(item, idx) in pedido.filter(p => !p.id_cuenta_pedido)"
                      :key="idx"
                      class="inline-flex items-center gap-1 bg-amber-50 border border-amber-200 text-amber-800 px-3 py-1 rounded-full text-sm font-medium"
                    >
                      <span v-if="item.cantidad > 1" class="font-bold">{{ item.cantidad }}×</span>
                      {{ item.Nombre }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Detalles / notas para cocina y barra -->
            <div>
              <p class="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider mb-2">
                <i class="bx bx-note me-1 text-amber-500"></i>Detalles para cocina/barra
                <span class="font-normal normal-case text-slate-400 ms-1">(opcional)</span>
              </p>
              <textarea
                v-model="notasPedido"
                rows="3"
                maxlength="500"
                class="w-full px-3 py-2 rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-700 text-amber-900 dark:text-amber-200 placeholder-amber-400 dark:placeholder-amber-600 focus:ring-2 focus:ring-amber-400 focus:border-transparent outline-none resize-none text-sm"
                placeholder="Ej: Sin cebolla en la pasta, mesa apurada, alérgico a mariscos…"
              ></textarea>
              <div class="flex flex-wrap gap-1.5 mt-2">
                <button
                  v-for="chip in ['Para llevar', 'Sin sal', 'Sin picante', 'Apurado', 'Cumpleaños', 'Sin cebolla']"
                  :key="chip"
                  type="button"
                  @click="notasPedido = notasPedido ? notasPedido + ', ' + chip : chip"
                  class="px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border border-amber-300 dark:border-amber-600 hover:bg-amber-200 dark:hover:bg-amber-800/60 transition-colors"
                >
                  {{ chip }}
                </button>
              </div>
              <p class="text-right text-xs text-slate-400 mt-1">{{ notasPedido.length }}/500</p>
            </div>

            <!-- Total -->
            <div class="flex justify-between items-center pt-2 border-t border-slate-200 dark:border-slate-700">
              <span class="text-sm font-semibold text-slate-600 dark:text-slate-400">Total del pedido:</span>
              <span class="text-xl font-bold text-teal-700 dark:text-teal-400">Q{{ totalPedido.toFixed(2) }}</span>
            </div>
          </div>

          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 flex gap-3 border-t border-slate-200 dark:border-slate-700 rounded-b-2xl">
            <button @click="closeModalConfirmEnvio" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-700/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cancelar
            </button>
            <button @click="confirmarEnvioPedido" class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-teal-600/90 to-emerald-600/90 hover:from-teal-700 hover:to-emerald-700 text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2">
              <i class="bx bx-send"></i>Enviar pedido
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Cerrar Pedido -->
    <transition name="modal">
      <div v-if="showModalCerrarPedido" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="closeModalCerrarPedido">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full">
          <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white">Confirmar cierre</h3>
          </div>
          <div class="p-6">
            <p class="text-slate-700 dark:text-slate-300">¿Estás seguro que deseas cerrar este pedido? Una vez cerrado ya no podrás agregar más cuentas ni platillos.</p>
          </div>
          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 flex gap-3">
            <button @click="closeModalCerrarPedido" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-700/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cancelar
            </button>
            <button @click="confirmarCerrarPedido" class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-rose-500/85 to-rose-600/85 hover:from-rose-600/95 hover:to-rose-700/95 text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all">
              Cerrar pedido
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Agregar Cuenta -->
    <transition name="modal">
      <div v-if="showModalAgregarCuenta" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="closeModalAgregarCuenta">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full">
          <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white">Agregar cuenta</h3>
          </div>
          <div class="p-6">
            <p class="text-slate-700 dark:text-slate-300">¿Estás seguro que deseas agregar una nueva cuenta?</p>
          </div>
          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 flex gap-3">
            <button @click="closeModalAgregarCuenta" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-700/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cancelar
            </button>
            <button @click="confirmarAgregarCuenta" class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-primary/90 to-secondary/90 hover:from-primary hover:to-secondary text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all">
              Agregar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Reasignar Platillos -->
    <transition name="modal">
      <div v-if="showModalReasignar" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="closeModalReasignar">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
          <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 sticky top-0 bg-white dark:bg-slate-800 z-10 flex items-center justify-between">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
              <i class="bx bx-transfer text-blue-600"></i>
              Mover platillos entre cuentas
            </h3>
            <button @click="closeModalReasignar" class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-400 transition-colors">
              <i class="bx bx-x text-2xl"></i>
            </button>
          </div>

          <div class="p-6 space-y-4">
            <!-- Grid de cuentas -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div v-for="cuenta in detallesPorCuenta" :key="cuenta.IdCuentaPedido" class="border border-slate-200 dark:border-slate-700 rounded-xl p-4">
                <h4 class="font-bold text-slate-900 dark:text-white mb-3 flex items-center justify-between">
                  <span>{{ cuenta.NombreCuenta }}</span>
                  <span class="text-sm font-normal px-2 py-1 bg-slate-100 dark:bg-slate-700 rounded-full">
                    {{ cuenta.detalles.length }} items
                  </span>
                </h4>

                <div v-if="cuenta.detalles.length === 0" class="text-center py-4 text-slate-400 text-sm">
                  Sin platillos asignados
                </div>

                <div v-else class="space-y-2 max-h-60 overflow-y-auto">
                  <div
                    v-for="detalle in cuenta.detalles"
                    :key="detalle.IdCuentaDetalle"
                    class="bg-slate-50 dark:bg-slate-900 rounded-lg p-3 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer"
                    @click="seleccionarDetalle(detalle, cuenta)"
                    :class="{ 'ring-2 ring-blue-500': detalleSeleccionado?.IdCuentaDetalle === detalle.IdCuentaDetalle }"
                  >
                    <div class="flex justify-between items-start gap-2">
                      <div class="flex-1">
                        <p class="font-semibold text-slate-900 dark:text-white text-sm">{{ detalle.nombre_platillo }}</p>
                        <p class="text-xs text-slate-600 dark:text-slate-400">
                          Cantidad: {{ detalle.Cantidad }} | Subtotal: Q{{ (detalle.Subtotal || 0).toFixed(2) }}
                        </p>
                      </div>
                      <i v-if="detalleSeleccionado?.IdCuentaDetalle === detalle.IdCuentaDetalle" class="bx bx-check-circle text-blue-600 text-xl"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Sección de reasignación -->
            <div v-if="detalleSeleccionado" class="border-t border-slate-200 dark:border-slate-700 pt-4">
              <div class="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-4 space-y-4">
                <h5 class="font-bold text-slate-900 dark:text-white">Platillo seleccionado:</h5>
                <div class="bg-white dark:bg-slate-800 rounded-lg p-3">
                  <p class="font-semibold text-slate-900 dark:text-white">{{ detalleSeleccionado.nombre_platillo }}</p>
                  <p class="text-sm text-slate-600 dark:text-slate-400">
                    De: <span class="font-semibold">{{ cuentaOrigenSeleccionada?.NombreCuenta }}</span>
                  </p>
                  <p class="text-sm text-slate-600 dark:text-slate-400">
                    Cantidad disponible: {{ detalleSeleccionado.Cantidad }}
                  </p>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                      Cantidad a mover
                    </label>
                    <input
                      v-model.number="cantidadReasignar"
                      type="number"
                      min="1"
                      :max="detalleSeleccionado.Cantidad"
                      class="w-full px-4 py-2 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">
                      Mover a cuenta
                    </label>
                    <select
                      v-model="cuentaDestinoSeleccionada"
                      class="w-full px-4 py-2 rounded-lg border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                      <option :value="null" disabled>Seleccionar cuenta...</option>
                      <option
                        v-for="cuenta in detallesPorCuenta.filter(c => c.IdCuentaPedido !== cuentaOrigenSeleccionada?.IdCuentaPedido)"
                        :key="cuenta.IdCuentaPedido"
                        :value="cuenta"
                      >
                        {{ cuenta.NombreCuenta }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="flex gap-3">
                  <button
                    @click="cancelarSeleccion"
                    class="flex-1 px-4 py-2 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600 transition-all"
                  >
                    Cancelar selección
                  </button>
                  <button
                    @click="confirmarReasignacion"
                    :disabled="!cuentaDestinoSeleccionada || cantidadReasignar < 1 || cantidadReasignar > detalleSeleccionado.Cantidad"
                    class="flex-1 px-4 py-2 rounded-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Mover platillo
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 sticky bottom-0">
            <button
              @click="closeModalReasignar"
              class="w-full px-4 py-3 rounded-full bg-slate-200 dark:bg-slate-700 text-slate-700 dark:text-slate-300 font-semibold hover:bg-slate-300 dark:hover:bg-slate-600 transition-all"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Notas -->
    <transition name="modal">
      <div v-if="showModalNotas" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="closeModalNotas">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full">
          <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white">Notas del pedido</h3>
            <button @click="closeModalNotas" class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-400 transition-colors">
              <i class="bx bx-x text-2xl"></i>
            </button>
          </div>
          <div class="p-6">
            <textarea
              v-model="notasPedido"
              rows="4"
              class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none resize-none"
              placeholder="Escribe las notas del pedido..."
            ></textarea>
          </div>
          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 flex gap-3">
            <button @click="closeModalNotas" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-700/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cancelar
            </button>
            <button @click="guardarNotas" class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-teal-600/90 to-emerald-600/90 hover:from-teal-700 hover:to-emerald-700 text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Empacar -->
    <transition name="modal">
      <div v-if="showModalEmpacar" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="closeModalEmpacar">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full">
          <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white">Empacar platillo</h3>
          </div>
          <div class="p-6 space-y-4">
            <p class="font-semibold text-slate-900 dark:text-white">{{ itemEmpacar?.platillo }}</p>
            <div>
              <label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2">Cantidad a empacar</label>
              <input
                type="number"
                v-model.number="cantidadEmpacar"
                :min="1"
                :max="itemEmpacar ? itemEmpacar.cantidad - (itemEmpacar.cantidad_empacada || 0) : 1"
                class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
              />
            </div>
          </div>
          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 flex gap-3">
            <button @click="closeModalEmpacar" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-700/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cancelar
            </button>
            <button @click="confirmarEmpaque" class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-primary/90 to-secondary/90 hover:from-primary hover:to-secondary text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all">
              Empacar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Cancelar -->
    <transition name="modal">
      <div v-if="showModalCancelar" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="closeModalCancelar">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
          <div class="px-6 py-4 border-b border-slate-200 dark:border-slate-700">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white">Cancelar platillo</h3>
          </div>
          <div class="p-6 space-y-4">
            <p class="font-semibold text-slate-900 dark:text-white">{{ itemSeleccionado?.platillo }}</p>

            <div>
              <label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2">Tipo de cancelación</label>
              <select
                v-model="tipoCancelacion"
                class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
              >
                <option value="2" :disabled="itemSeleccionado?.estado_detalle === 1">Cancelación normal</option>
                <option value="3">Cancelación especial (higiene/defecto)</option>
              </select>
            </div>

            <div>
              <label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2">Cantidad a cancelar</label>
              <input
                type="number"
                v-model.number="cantidadCancelar"
                min="1"
                :max="itemSeleccionado ? itemSeleccionado.cantidad - (itemSeleccionado.cantidad_cancelada || 0) : 1"
                class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none"
              />
            </div>

            <div>
              <label class="block text-sm font-semibold text-slate-700 dark:text-slate-300 mb-2">Motivo</label>
              <textarea
                v-model="motivoCancelacion"
                rows="3"
                class="w-full px-4 py-3 rounded-xl bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 focus:ring-2 focus:ring-primary focus:border-transparent outline-none resize-none"
              ></textarea>
            </div>
          </div>
          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 flex gap-3">
            <button @click="closeModalCancelar" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-700/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cerrar
            </button>
            <button @click="confirmarCancelacion" class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-rose-500/85 to-rose-600/85 hover:from-rose-600/95 hover:to-rose-700/95 text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all">
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Confirmar Eliminar Cuenta -->
    <transition name="modal">
      <div v-if="showModalEliminarCuenta" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" @click.self="closeModalEliminarCuenta">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full border border-slate-200 dark:border-slate-700">
          <div class="px-6 py-5 border-b border-slate-200 dark:border-slate-700">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white flex items-center gap-2">
              <i class="bx bx-error-circle text-amber-500 text-2xl"></i>
              Confirmar eliminación
            </h3>
          </div>
          <div class="p-6 space-y-4">
            <p class="text-slate-700 dark:text-slate-300 leading-relaxed">
              ¿Estás seguro que deseas eliminar la cuenta <strong class="text-slate-900 dark:text-white">{{ cuentaAEliminar?.NombreCuenta }}</strong>?
            </p>
            <div v-if="cuentaAEliminar && Number(cuentaAEliminar.Total) > 0" class="p-4 rounded-xl bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800">
              <div class="flex items-start gap-3">
                <i class="bx bx-info-circle text-amber-600 dark:text-amber-400 text-xl flex-shrink-0 mt-0.5"></i>
                <div class="flex-1">
                  <p class="font-semibold text-amber-900 dark:text-amber-100 mb-1">Advertencia</p>
                  <p class="text-sm text-amber-800 dark:text-amber-200">
                    Esta cuenta tiene productos asignados (Total: Q{{ cuentaAEliminar.Total }}). Los productos se reasignarán a la primera cuenta disponible.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 flex gap-3 rounded-b-2xl">
            <button @click="closeModalEliminarCuenta" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-800/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-700/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cancelar
            </button>
            <button @click="confirmarEliminarCuentaFinal" class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-rose-500/85 to-rose-600/85 hover:from-rose-600/95 hover:to-rose-700/95 text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all">
              Sí, eliminar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal Configurar Platillo -->
    <transition name="modal">
      <div v-if="showModalConfig" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm overflow-y-auto" @click.self="closeModalConfig">
        <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-3xl w-full my-8 max-h-[90vh] flex flex-col">
          <div class="px-6 py-4 bg-white dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between rounded-t-2xl flex-shrink-0">
            <h3 class="text-xl font-bold text-slate-900 dark:text-white">
              Configurar: {{ platilloSeleccionado?.Nombre }}
            </h3>
            <button @click="closeModalConfig" class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-400 transition-colors">
              <i class="bx bx-x text-2xl"></i>
            </button>
          </div>

          <div class="p-6 space-y-6 overflow-y-auto flex-1" ref="modalConfigContent">
            <!-- Ingredientes -->
            <div v-if="ingredientesSeleccionados.length" class="space-y-3">
              <h4 class="text-lg font-bold text-slate-900 dark:text-white flex items-center gap-2">
                <i class="bx bx-lemon text-green-600"></i>
                Ingredientes
              </h4>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <label
                  v-for="(ing, idx) in ingredientesSeleccionados"
                  :key="ing.id_producto"
                  class="flex items-center gap-3 px-4 py-3 rounded-xl border-2 transition-all cursor-pointer"
                  :class="ingredientesSeleccionados[idx].quitar === 0
                    ? 'border-green-500 bg-green-50 dark:bg-green-900/20'
                    : 'border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 hover:border-slate-300 dark:hover:border-slate-600'"
                >
                  <input
                    type="checkbox"
                    v-model="ingredientesSeleccionados[idx].quitar"
                    :true-value="0"
                    :false-value="1"
                    :id="'ing-' + ing.id_producto"
                    class="w-5 h-5 rounded border-slate-300 text-primary focus:ring-primary"
                  />
                  <span class="flex-1 font-medium text-slate-900 dark:text-white">{{ ing.nombre }}</span>
                  <i v-if="ingredientesSeleccionados[idx].quitar === 0" class="bx bx-check text-green-600 text-xl"></i>
                </label>
              </div>
            </div>

            <!-- Grupos de opciones -->
            <div v-if="platilloSeleccionado?.grupos?.length" class="space-y-4">
              <h4 class="text-lg font-bold text-slate-900 dark:text-white flex items-center gap-2">
                <i class="bx bx-customize text-primary"></i>
                Opciones
              </h4>

              <div
                v-for="grupo in platilloSeleccionado.grupos"
                :key="grupo.IdPlatilloGrupoOpcion"
                :data-grupo-id="grupo.IdGrupoOpcion"
                class="bg-slate-50 dark:bg-slate-900 rounded-xl p-4 border border-slate-200 dark:border-slate-700 space-y-3"
              >
                <!-- Header del grupo -->
                <div class="flex justify-between items-start gap-4 pb-3 border-b border-slate-200 dark:border-slate-700">
                  <h5 class="font-bold text-slate-900 dark:text-white">
                    {{ grupo.grupo?.NombreGrupo || 'Opciones' }}
                  </h5>
                  <div class="text-right">
                    <p class="text-xs text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                      Min: {{ getGroupMin(grupo) }} | Max: {{ getGroupMax(grupo) }}
                    </p>
                    <p class="text-sm font-bold" :class="selectedCount(grupo.IdGrupoOpcion) < getGroupMin(grupo) ? 'text-red-600' : 'text-green-600'">
                      Seleccionadas: {{ selectedCount(grupo.IdGrupoOpcion) }}
                    </p>
                  </div>
                </div>

                <!-- Items del grupo -->
                <div class="space-y-2">
                  <div
                    v-for="item in grupo.items"
                    :key="item.IdGrupoOpcionItem"
                    class="flex items-center justify-between gap-4 px-4 py-3 rounded-lg border-2 transition-all"
                    :class="isSelected(grupo.IdGrupoOpcion, item.IdOpcion)
                      ? 'border-primary bg-primary/5'
                      : 'border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800'"
                  >
                    <label class="flex items-center gap-3 flex-1 cursor-pointer">
                      <input
                        type="checkbox"
                        :id="'op-' + item.IdGrupoOpcionItem"
                        :checked="isSelected(grupo.IdGrupoOpcion, item.IdOpcion)"
                        :disabled="disableNewSelect(grupo, item)"
                        @change="toggleCheck(grupo, item)"
                        class="w-5 h-5 rounded border-slate-300 text-primary focus:ring-primary disabled:opacity-50"
                      />
                      <div class="flex-1">
                        <span class="font-medium text-slate-900 dark:text-white block">
                          {{ item.opcion?.Nombre || 'Opción' }}
                        </span>
                        <span v-if="parseFloat(item.PrecioExtra) > 0" class="text-sm font-bold text-green-600">
                          +Q{{ item.PrecioExtra }}
                        </span>
                      </div>
                    </label>

                    <!-- Controles de cantidad -->
                    <div v-if="parseFloat(item.PrecioExtra || 0) > 0 && isSelected(grupo.IdGrupoOpcion, item.IdOpcion)" class="flex items-center gap-2">
                      <button
                        @click="decQty(grupo.IdGrupoOpcion, item.IdOpcion)"
                        :disabled="getSelectedQty(grupo.IdGrupoOpcion, item.IdOpcion) <= 1"
                        class="w-8 h-8 flex items-center justify-center rounded-lg bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <i class="bx bx-minus"></i>
                      </button>
                      <span class="w-8 text-center font-bold text-slate-900 dark:text-white">
                        {{ getSelectedQty(grupo.IdGrupoOpcion, item.IdOpcion) }}
                      </span>
                      <button
                        @click="incQty(grupo.IdGrupoOpcion, item)"
                        :disabled="selectedCount(grupo.IdGrupoOpcion) >= getGroupMax(grupo)"
                        class="w-8 h-8 flex items-center justify-center rounded-lg bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <i class="bx bx-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Mensaje de error de validación -->
                <div v-if="validationErrors[grupo.IdGrupoOpcion]" class="flex items-center gap-2 px-3 py-2 rounded-lg bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800">
                  <i class="bx bx-error text-red-600"></i>
                  <span class="text-sm text-red-700 dark:text-red-400 font-medium">
                    {{ validationErrors[grupo.IdGrupoOpcion] }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Cantidad de platillos -->
            <div class="border-t border-slate-200 dark:border-slate-700 pt-6">
              <h4 class="text-lg font-bold text-slate-900 dark:text-white mb-3 flex items-center gap-2">
                <i class="bx bx-hash text-primary"></i>
                Cantidad
              </h4>
              <div class="flex items-center justify-center gap-4 bg-slate-50 dark:bg-slate-900 rounded-xl p-4">
                <button
                  @click="cantidadPlatilloModal > 1 && cantidadPlatilloModal--"
                  :disabled="cantidadPlatilloModal <= 1"
                  class="flex items-center justify-center w-10 h-10 rounded-lg bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <i class="bx bx-minus"></i>
                </button>
                <input
                  v-model.number="cantidadPlatilloModal"
                  type="number"
                  min="1"
                  max="50"
                  class="w-20 text-center px-3 py-2 rounded-lg bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 text-slate-900 dark:text-white font-bold text-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
                <button
                  @click="cantidadPlatilloModal < 50 && cantidadPlatilloModal++"
                  :disabled="cantidadPlatilloModal >= 50"
                  class="flex items-center justify-center w-10 h-10 rounded-lg bg-slate-200 dark:bg-slate-700 hover:bg-slate-300 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <i class="bx bx-plus"></i>
                </button>
              </div>
            </div>

            <!-- Subtotal Preview -->
            <div class="bg-gradient-to-r from-primary/10 to-secondary/10 border border-primary/20 rounded-xl p-4">
              <div class="space-y-2">
                <div class="flex justify-between items-center">
                  <span class="text-slate-700 dark:text-slate-300 font-medium">Precio unitario:</span>
                  <span class="text-lg font-bold text-slate-900 dark:text-white">
                    Q{{ calcularPrecioSeleccionado().toFixed(2) }}
                  </span>
                </div>
                <div class="flex justify-between items-center pt-2 border-t border-primary/20">
                  <span class="text-slate-700 dark:text-slate-300 font-medium">Total ({{ cantidadPlatilloModal }} × ):</span>
                  <span class="text-2xl font-bold text-slate-900 dark:text-white">
                    Q{{ (calcularPrecioSeleccionado() * cantidadPlatilloModal).toFixed(2) }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="px-6 py-4 bg-slate-50 dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 flex gap-3 rounded-b-2xl flex-shrink-0">
            <button @click="closeModalConfig" class="flex-1 px-4 py-3 rounded-full bg-slate-100 dark:bg-slate-700/70 text-slate-600 dark:text-slate-300 font-semibold hover:bg-slate-200 dark:hover:bg-slate-600/80 border-0 shadow-sm hover:shadow-md transition-all">
              Cancelar
            </button>
            <button @click="confirmarSeleccion" class="flex-1 px-4 py-3 rounded-full bg-gradient-to-r from-teal-600/90 to-emerald-600/90 hover:from-teal-700 hover:to-emerald-700 text-white font-semibold border-0 shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2">
              <i class="bx bx-check text-xl"></i>
              <span>Agregar al pedido</span>
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { API_URL } from "@/config/config";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "MenuMesero",
  data() {
    return {
      // Modales
      showModalAbrirPedido: false,
      showModalConfirmEnvio: false,
      showModalCerrarPedido: false,
      showModalAgregarCuenta: false,
      showModalNotas: false,
      showModalEmpacar: false,
      showModalCancelar: false,
      showModalConfig: false,
      showModalEliminarCuenta: false,
      showModalReasignar: false,

      // Data existente
      cuentaAEliminar: null,
      notasPedido: "",
      editandoNotas: false,
      itemEmpacar: null,
      cantidadEmpacar: 1,
      detallesPorCuenta: [],
      cuentaOrigenSeleccionada: null,
      cuentaDestinoSeleccionada: null,
      detalleSeleccionado: null,
      cantidadReasignar: 1,
      menu: [],
      busqueda: "",
      pedido: [],
      cuentas: [],
      categoriaActiva: null,
      cargandoPedido: true,
      itemSeleccionado: null,
      cantidadCancelar: 1,
      motivoCancelacion: "",
      tipoCancelacion: 2,
      platilloSeleccionado: null,
      ingredientesSeleccionados: [],
      numeroMesa: null,
      opcionesSeleccionadas: {},
      validationErrors: {},
      cantidadPlatilloModal: 1,
      idMesa: null,
      idEmpleado: null, // Se establece en mounted desde el store
      paraLlevar: 0,
      mostrarToast: false,
      alerta: { mensaje: "", tipo: "success" },
      pedidoAnterior: [],
      totalAnterior: 0,
      pedidoAbierto: false,
      idPedido: null,
      numCuentas: 1,
      cuentasTemp: [{ nombre_cuenta: "Cuenta 1" }],
      cargarAHabitacion: false,
      habitacionSeleccionada: null,
      habitacionesDisponibles: [],
      habitacionesFiltradas: [],
      busquedaHabitacion: '',
      cargandoHabitaciones: false,
      // Modal asignar habitación a cuenta existente
      showModalAsignarHabitacion: false,
      cuentaSeleccionadaHabitacion: null,
      habitacionSeleccionadaCuenta: null,
      habitacionesFiltradasCuenta: [],
      busquedaHabitacionCuenta: '',
    };
  },
  watch: {
    numCuentas(n) {
      this.cuentasTemp = Array.from({ length: n }, (_, i) => ({
        nombre_cuenta: `Cuenta ${i + 1}`
      }));
    },
  },
  computed: {
    ...mapGetters(['getUser']),
    usuario() {
      return this.getUser;
    },
    platillosFiltrados() {
      // Si hay búsqueda, buscar en todas las categorías
      if (this.busqueda && this.busqueda.trim()) {
        const t = this.busqueda.toLowerCase();
        const todosPlatillos = [];
        this.menu.forEach(categoria => {
          if (categoria.platillos) {
            categoria.platillos.forEach(p => {
              if (p.Nombre.toLowerCase().includes(t) ||
                  (p.Descripcion && p.Descripcion.toLowerCase().includes(t))) {
                todosPlatillos.push(p);
              }
            });
          }
        });
        return todosPlatillos;
      }
      // Sin búsqueda, mostrar categoría activa
      return this.categoriaActiva?.platillos || [];
    },
    totalPedido() {
      return this.pedido.reduce((acc, item) => acc + this.subtotalItem(item), 0);
    },
  },
  methods: {
    // Modal methods
    async abrirModalAbrirPedido() {
      // Cargar habitaciones ANTES de mostrar el modal
      this.cargandoHabitaciones = true;
      await this.cargarHabitacionesDisponibles();
      this.habitacionesFiltradas = Array.isArray(this.habitacionesDisponibles) ? [...this.habitacionesDisponibles] : [];
      this.cargandoHabitaciones = false;

      // Mostrar modal después de cargar los datos
      this.showModalAbrirPedido = true;
    },
    closeModalAbrirPedido() {
      this.showModalAbrirPedido = false;
      this.cargarAHabitacion = false;
      this.habitacionSeleccionada = null;
      this.busquedaHabitacion = '';
      this.habitacionesFiltradas = [];
    },
    abrirModalCerrarPedido() {
      this.showModalCerrarPedido = true;
    },
    closeModalCerrarPedido() {
      this.showModalCerrarPedido = false;
    },
    abrirModalAgregarCuenta() {
      this.showModalAgregarCuenta = true;
    },
    closeModalAgregarCuenta() {
      this.showModalAgregarCuenta = false;
    },
    abrirModalNotas() {
      this.showModalNotas = true;
    },
    closeModalNotas() {
      this.showModalNotas = false;
    },
    abrirConfirmacionEnvio() {
      this.showModalConfirmEnvio = true;
    },
    closeModalConfirmEnvio() {
      this.showModalConfirmEnvio = false;
    },
    closeModalEmpacar() {
      this.showModalEmpacar = false;
    },
    closeModalCancelar() {
      this.showModalCancelar = false;
    },
    closeModalConfig() {
      this.showModalConfig = false;
      this.cantidadPlatilloModal = 1;
    },
    closeModalEliminarCuenta() {
      this.showModalEliminarCuenta = false;
      this.cuentaAEliminar = null;
    },
    async abrirModalReasignar() {
      try {
        await this.cargarDetallesPorCuenta();
        this.showModalReasignar = true;
      } catch (error) {
        this.mostrarAlerta("Error al cargar los detalles", "danger");
      }
    },
    closeModalReasignar() {
      this.showModalReasignar = false;
      this.detalleSeleccionado = null;
      this.cuentaOrigenSeleccionada = null;
      this.cuentaDestinoSeleccionada = null;
      this.cantidadReasignar = 1;
    },
    seleccionarDetalle(detalle, cuenta) {
      this.detalleSeleccionado = detalle;
      this.cuentaOrigenSeleccionada = cuenta;
      this.cantidadReasignar = 1;
      this.cuentaDestinoSeleccionada = null;
    },
    cancelarSeleccion() {
      this.detalleSeleccionado = null;
      this.cuentaOrigenSeleccionada = null;
      this.cuentaDestinoSeleccionada = null;
      this.cantidadReasignar = 1;
    },
    async cargarDetallesPorCuenta() {
      try {
        const { data } = await axios.get(`${API_URL}/detalle-cuentas/${this.idPedido}`);
        this.detallesPorCuenta = data;
      } catch (error) {
        console.error("Error al cargar detalles:", error);
        throw error;
      }
    },
    async confirmarReasignacion() {
      if (!this.detalleSeleccionado || !this.cuentaDestinoSeleccionada) {
        this.mostrarAlerta("Selecciona una cuenta de destino", "danger");
        return;
      }

      if (this.cantidadReasignar < 1 || this.cantidadReasignar > this.detalleSeleccionado.Cantidad) {
        this.mostrarAlerta("Cantidad inválida", "danger");
        return;
      }

      try {
        await axios.post(`${API_URL}/pedido/reasignar-detalle`, {
          id_cuenta_detalle: this.detalleSeleccionado.IdCuentaDetalle,
          id_cuenta_destino: this.cuentaDestinoSeleccionada.IdCuentaPedido,
          cantidad: this.cantidadReasignar
        });

        this.mostrarAlerta("Platillo movido exitosamente", "success");
        this.cancelarSeleccion();
        await this.cargarDetallesPorCuenta();
        await this.cargarPedidoAbierto(); // Recargar el pedido
      } catch (error) {
        console.error("Error al reasignar:", error);
        this.mostrarAlerta(
          error.response?.data?.error || "Error al mover el platillo",
          "danger"
        );
      }
    },

    async guardarNotas() {
      if (!this.idPedido) return;

      try {
        await axios.put(
          `${API_URL}/pedido/${this.idPedido}/notas`,
          { notas: this.notasPedido }
        );

        this.mostrarAlerta("Notas guardadas correctamente", "success");
        this.editandoNotas = false;
        this.closeModalNotas();
      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.error || "Error al guardar notas",
          "danger"
        );
      }
    },

    cancelarEdicionNotas() {
      this.editandoNotas = false;
      this.cargarPedidoAbierto();
    },

    async confirmarEmpaque() {
      try {
        const { data } = await axios.post(
          `${API_URL}/empaque-pedido/${this.itemEmpacar.id_detalle_pedido}/empacar`,
          { cantidad: this.cantidadEmpacar }
        );

        this.mostrarAlerta(data.mensaje || "Empacado con éxito", "success");
        await this.cargarPedidoAbierto();
        this.closeModalEmpacar();
      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.error || "Error al empacar",
          "danger"
        );
      }
    },

    abrirModalEmpacar(item) {
      this.itemEmpacar = item;
      this.cantidadEmpacar = 1;
      this.showModalEmpacar = true;
    },

    puedeEmpacar(item) {
      return Number(item.cantidad_empacada || 0) < Number(item.cantidad);
    },

    calcularPrecioSeleccionado() {
      if (!this.platilloSeleccionado) return 0;
      const precioBase = parseFloat(this.platilloSeleccionado.Precio);
      const extras = this.normalizeOpciones(this.opcionesSeleccionadas)
        .reduce((acc, o) => acc + ((parseFloat(o.PrecioExtra) || 0) * (o.cantidad || 1)), 0);
      return precioBase + extras;
    },

    async cerrarPedido() {
      if (!this.idPedido) {
        this.mostrarAlerta("No hay un pedido abierto para cerrar", "danger");
        return;
      }

      try {
        const payload = { id_pedido: this.idPedido };
        const { data } = await axios.put(`${API_URL}/cerrar-pedido`, payload);

        this.mostrarAlerta(data.mensaje || "Pedido cerrado correctamente", "success");

        this.pedidoAbierto = false;
        this.idPedido = null;
        this.pedidoAnterior = [];
        this.totalAnterior = 0;
        this.cuentas = [];
      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.error || "Error al cerrar el pedido",
          "danger"
        );
      }
    },

    confirmarCerrarPedido() {
      this.closeModalCerrarPedido();
      this.cerrarPedido();
    },

    async cargarCuentas() {
      try {
        const { data } = await axios.get(`${API_URL}/pedido-cuentas/${this.idPedido}`);
        this.cuentas = data.cuentas;
      } catch (err) {
        this.cuentas = [];
      }
    },

    async agregarCuenta(nombre = null) {
      try {
        const payload = {
          id_pedido: this.idPedido,
          nombre_cuenta: nombre
        };
        await axios.post(`${API_URL}/pedido/crear-cuenta`, payload);
        await this.cargarCuentas();
        this.mostrarAlerta("Cuenta creada con éxito", "success");
      } catch (err) {
        this.mostrarAlerta(err.response?.data?.error || "Error al crear cuenta", "danger");
      }
    },

    confirmarEliminarCuenta(cuenta) {
      this.cuentaAEliminar = cuenta;
      this.showModalEliminarCuenta = true;
    },

    async confirmarEliminarCuentaFinal() {
      if (!this.cuentaAEliminar) return;

      const idCuenta = this.cuentaAEliminar.IdCuentaPedido;

      try {
        // Si la cuenta tiene productos en el pedido nuevo (carrito), reasignarlos
        const productosEnCuenta = this.pedido.filter(p => p.id_cuenta_pedido === idCuenta);

        if (productosEnCuenta.length > 0) {
          const otrasCuentas = this.cuentas.filter(c => c.IdCuentaPedido !== idCuenta);
          if (otrasCuentas.length === 0) {
            this.mostrarAlerta("No puedes eliminar la última cuenta con productos asignados", "danger");
            this.closeModalEliminarCuenta();
            return;
          }

          // Reasignar productos a la primera cuenta disponible
          const primeraOtraCuenta = otrasCuentas[0].IdCuentaPedido;
          productosEnCuenta.forEach(item => {
            item.id_cuenta_pedido = primeraOtraCuenta;
          });
        }

        // Eliminar en el backend
        await axios.delete(`${API_URL}/pedido/cuenta/${idCuenta}`);

        // Eliminar localmente y recargar para obtener el estado actualizado
        this.cuentas = this.cuentas.filter(c => c.IdCuentaPedido !== idCuenta);

        // Recargar cuentas para asegurarnos de tener el estado correcto del servidor
        await this.cargarCuentas();

        this.mostrarAlerta("Cuenta eliminada" + (productosEnCuenta.length ? ". Productos reasignados" : ""), "success");
        this.closeModalEliminarCuenta();

      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.error || "Error al eliminar cuenta",
          "danger"
        );
      }
    },

    abrirModalCancelar(item) {
      this.cargarPedidoAbierto().then(() => {
        const detalleActualizado = this.pedidoAnterior.find(
          d => d.id_detalle_pedido === item.id_detalle_pedido
        );

        if (!detalleActualizado) {
          this.mostrarAlerta("Este detalle ya no está disponible", "danger");
          return;
        }

        this.itemSeleccionado = detalleActualizado;
        this.cantidadCancelar = 1;
        this.motivoCancelacion = "";
        this.tipoCancelacion = detalleActualizado.estado_detalle === 1 ? 3 : 2;
        this.showModalCancelar = true;
      });
    },

    async confirmarCancelacion() {
      if (!this.motivoCancelacion) {
        this.mostrarAlerta("Debes ingresar un motivo de cancelación", "danger");
        return;
      }
      try {
        await axios.put(`${API_URL}/pedidos-mesa/cancelar-detalle`, {
          id_detalle_pedido: this.itemSeleccionado.id_detalle_pedido,
          cantidad_cancelar: this.cantidadCancelar,
          motivo: this.motivoCancelacion,
          tipo_cancelacion: this.tipoCancelacion
        });

        this.mostrarAlerta("Detalle cancelado con éxito", "success");
        await this.cargarPedidoAbierto();
        this.closeModalCancelar();
      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.error || "Error al cancelar detalle",
          "danger"
        );
      }
    },

    async confirmarAbrirPedido() {
      try {
        const payload = {
          id_mesa: this.idMesa,
          id_empleado: this.idEmpleado,
          para_llevar: this.paraLlevar,
          cuentas: this.cuentasTemp,
          id_reserva_habitacion: this.cargarAHabitacion ? this.habitacionSeleccionada : null
        };

        const { data } = await axios.post(`${API_URL}/abrir-pedido`, payload);

        this.idPedido = data.pedido.IdPedido;
        this.pedidoAbierto = true;

        // Usar las cuentas directamente de la respuesta
        if (data.cuentas && data.cuentas.length > 0) {
          this.cuentas = data.cuentas;
        } else {
          // Fallback: cargar desde el endpoint
          await this.cargarCuentas();
        }

        this.mostrarAlerta("Pedido abierto con éxito", "success");
        this.closeModalAbrirPedido();
      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.error || "Error al abrir pedido",
          "danger"
        );
      }
    },

    puedeCancelar(item) {
      const estCocina = Number(item.estado_detalle);
      const estBarra  = Number(item.estado_detalle_barra);

      if (estCocina === 0 || estBarra === 0) {
        return true;
      }

      return false;
    },

    estadoVisual(item) {
      const estCocina = Number(item.estado_detalle);
      const estBarra  = Number(item.estado_detalle_barra);
      if (estCocina === 2 || estBarra === 2) return "cancelado";
      if (estCocina === 0 || estBarra === 0) return "pendiente";
      if (estCocina === 1 && estBarra === 1) return "entregado";
      if (estCocina === 3 && estBarra === 3) return "cancelado";
      return "pendiente";
    },

    esEntregado(item) {
      const tieneBarra = Array.isArray(item.grupos) && item.grupos.length > 0;

      if (!tieneBarra) {
        return item.estado_detalle === 1;
      }
      return item.estado_detalle === 1 && item.estado_detalle_barra === 1;
    },

    async obtenerNumeroMesa() {
      if (!this.idMesa) return;
      try {
        const { data } = await axios.get(`${API_URL}/mesas/${this.idMesa}`);
        this.numeroMesa = data.Numero;
      } catch (e) {
        this.numeroMesa = null;
      }
    },

    async cancelarDetalle(item) {
      try {
        await axios.put(`${API_URL}/pedidos-mesa/cancelar-detalle`, {
          id_detalle_pedido: item.id_detalle_pedido
        });
        this.mostrarAlerta("Detalle cancelado con éxito", "success");
        await this.cargarPedidoAbierto();
      } catch (err) {
        this.mostrarAlerta(
          err.response?.data?.error || "Error al cancelar detalle",
          "danger"
        );
      }
    },

    async cargarPedidoAbierto() {
      try {
        const { data } = await axios.get(`${API_URL}/mesa/${this.idMesa}/pedidos-abiertos`);

        this.idPedido = data.id_pedido;
        this.pedidoAbierto = true;
        this.pedidoAnterior = data.detalles || [];
        this.totalAnterior = data.total_pedido || 0;
        this.notasPedido = data.notas || "";

        await this.cargarCuentas();
      } catch (err) {
        this.idPedido = null;
        this.pedidoAbierto = false;
        this.pedidoAnterior = [];
        this.totalAnterior = 0;
        this.cuentas = [];
      } finally {
        this.cargandoPedido = false;
      }
    },

    confirmarEnvioPedido() {
      this.closeModalConfirmEnvio();
      this.enviarPedido();
    },

    async cargarMenu() {
      const res = await axios.get(`${API_URL}/menu`);
      this.menu = res.data;
    },

    cerrarToast() {
      this.mostrarToast = false;
    },

    mostrarAlerta(mensaje, tipo = "success") {
      this.alerta = { mensaje, tipo };
      this.mostrarToast = true;
      setTimeout(this.cerrarToast, 3000);
    },

    smoothScrollTo(container, targetTop, duration = 400) {
      const start = container.scrollTop;
      const distance = targetTop - start;
      if (Math.abs(distance) < 1) return;
      const startTime = performance.now();
      const step = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = progress < 0.5
          ? 2 * progress * progress
          : -1 + (4 - 2 * progress) * progress;
        container.scrollTop = start + distance * ease;
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    },

    toggleCategoria(cat) {
      this.categoriaActiva = this.categoriaActiva?.IdCategoria === cat.IdCategoria ? null : cat;
      if (this.categoriaActiva) {
        this.$nextTick(() => {
          if (this.$refs.platillosGrid) {
            const el = this.$refs.platillosGrid;
            const scrollContainer = document.querySelector('.main-content') || document.documentElement;
            const containerRect = scrollContainer.getBoundingClientRect();
            const elRect = el.getBoundingClientRect();
            const targetTop = scrollContainer.scrollTop + (elRect.top - containerRect.top) - 80;
            this.smoothScrollTo(scrollContainer, targetTop, 450);
          }
        });
      }
    },

    abrirModal(platillo) {
      this.platilloSeleccionado = platillo;
      this.ingredientesSeleccionados = platillo.receta.map(r => ({
        id_producto: r.IdProductoRestaurante,
        nombre: r.producto.NombreProducto,
        quitar: 0,
      }));
      this.opcionesSeleccionadas = {};
      this.validationErrors = {};
      this.cantidadPlatilloModal = 1;
      this.showModalConfig = true;
    },

    getOpcionesList(opciones) {
      return this.normalizeOpciones(opciones);
    },

    subtotalItem(item) {
      const precioBase = parseFloat(item.Precio) || 0;
      const extras = this.normalizeOpciones(item.config.opciones)
        .reduce((acc, o) => acc + ((parseFloat(o.PrecioExtra) || 0) * (o.cantidad || 1)), 0);
      return (precioBase + extras) * (item.cantidad || 1);
    },

    getGroupMin(grupo) {
      const inNested = Number(grupo?.grupo?.MinSelecciones);
      const inFlat = Number(grupo?.MinSelecciones);
      const min = !isNaN(inNested) ? inNested : (!isNaN(inFlat) ? inFlat : 0);
      return min < 0 ? 0 : min;
    },

    getGroupMax(grupo) {
      const fallback = Array.isArray(grupo.items) ? grupo.items.length : 0;
      const inNested = Number(grupo?.grupo?.MaxSelecciones);
      const inFlat = Number(grupo?.MaxSelecciones);
      const max = !isNaN(inNested) ? inNested : (!isNaN(inFlat) ? inFlat : fallback);
      return max < 1 ? fallback : max;
    },

    selectedCount(idGrupo) {
      const g = this.opcionesSeleccionadas[idGrupo];
      if (!g) return 0;
      return Object.values(g).reduce((acc, o) => acc + (o?.cantidad ? Number(o.cantidad) : 1), 0);
    },

    isSelected(idGrupo, idOpcion) {
      return !!(this.opcionesSeleccionadas[idGrupo] && this.opcionesSeleccionadas[idGrupo][idOpcion]);
    },

    getSelectedQty(idGrupo, idOpcion) {
      const g = this.opcionesSeleccionadas[idGrupo];
      if (!g || !g[idOpcion]) return 0;
      return g[idOpcion].cantidad || 1;
    },

    disableNewSelect(grupo, item) {
      const idGrupo = grupo.IdGrupoOpcion;
      const atMax = this.selectedCount(idGrupo) >= this.getGroupMax(grupo);
      const already = this.isSelected(idGrupo, item.IdOpcion);
      return !already && atMax;
    },

    toggleCheck(grupo, item) {
      const idGrupo = grupo.IdGrupoOpcion;
      const max = this.getGroupMax(grupo);
      if (!this.opcionesSeleccionadas[idGrupo]) this.opcionesSeleccionadas[idGrupo] = {};

      if (this.isSelected(idGrupo, item.IdOpcion)) {
        delete this.opcionesSeleccionadas[idGrupo][item.IdOpcion];
      } else {
        if (this.selectedCount(idGrupo) >= max) return;

        this.opcionesSeleccionadas[idGrupo][item.IdOpcion] = {
          ...item,
          IdGrupoOpcion: idGrupo,
          IdOpcion: item.IdOpcion,
          cantidad: 1
        };
      }
      delete this.validationErrors[idGrupo];

      // Auto-scroll to next group when max selections reached (only when selecting, not deselecting)
      const justSelected = this.isSelected(idGrupo, item.IdOpcion);
      const grupos = this.platilloSeleccionado?.grupos || [];
      const idxActual = grupos.findIndex(g => g.IdGrupoOpcion === idGrupo);
      const maxActual = this.getGroupMax(grupo);
      const countActual = this.selectedCount(idGrupo);
      if (justSelected && countActual >= maxActual && idxActual !== -1 && idxActual < grupos.length - 1) {
        const nextGrupo = grupos[idxActual + 1];
        this.$nextTick(() => {
          const container = this.$refs.modalConfigContent;
          if (container) {
            const nextEl = container.querySelector('[data-grupo-id="' + nextGrupo.IdGrupoOpcion + '"]');
            if (nextEl) {
              const containerRect = container.getBoundingClientRect();
              const elRect = nextEl.getBoundingClientRect();
              const targetTop = container.scrollTop + (elRect.top - containerRect.top) - 16;
              this.smoothScrollTo(container, targetTop, 400);
            }
          }
        });
      }
    },

    incQty(idGrupo, item) {
      const max = this.getGroupMax(this.findGrupoById(idGrupo));
      if (!this.opcionesSeleccionadas[idGrupo]) this.opcionesSeleccionadas[idGrupo] = {};

      if (!this.opcionesSeleccionadas[idGrupo][item.IdOpcion]) {
        if (this.selectedCount(idGrupo) >= max) return;

        this.opcionesSeleccionadas[idGrupo][item.IdOpcion] = {
          ...item,
          IdGrupoOpcion: idGrupo,
          IdOpcion: item.IdOpcion,
          cantidad: 1
        };
        return;
      }

      if (this.selectedCount(idGrupo) < max) {
        this.opcionesSeleccionadas[idGrupo][item.IdOpcion].cantidad =
          (this.opcionesSeleccionadas[idGrupo][item.IdOpcion].cantidad || 1) + 1;
      }
    },

    decQty(idGrupo, idOpcion) {
      const g = this.opcionesSeleccionadas[idGrupo];
      if (!g || !g[idOpcion]) return;
      const curr = g[idOpcion].cantidad || 1;
      if (curr > 1) g[idOpcion].cantidad = curr - 1;
      else delete g[idOpcion];
    },

    findGrupoById(idGrupo) {
      if (!this.platilloSeleccionado?.grupos) return null;
      return this.platilloSeleccionado.grupos.find(g => g.IdGrupoOpcion === idGrupo) || null;
    },

    confirmarSeleccion() {
      this.validationErrors = {};
      const faltantes = [];

      if (this.platilloSeleccionado?.grupos?.length) {
        for (const g of this.platilloSeleccionado.grupos) {
          const idG = g.IdGrupoOpcion;
          const min = this.getGroupMin(g);
          const cant = this.selectedCount(idG);
          if (cant < min) {
            const nombre = g.grupo?.NombreGrupo || 'Opciones';
            this.validationErrors[idG] = `Debes elegir al menos ${min} en "${nombre}". (Actual: ${cant})`;
            faltantes.push(nombre);
          }
        }
      }

      if (faltantes.length) {
        this.mostrarAlerta(`Faltan opciones obligatorias en: ${faltantes.join(', ')}`, "danger");
        return;
      }

      // Auto-asignar siempre la primera cuenta si existen cuentas
      let cuentaAsignada = null;
      if (this.cuentas && this.cuentas.length > 0) {
        cuentaAsignada = this.cuentas[0].IdCuentaPedido;
      }

      this.pedido.push({
        ...this.platilloSeleccionado,
        cantidad: this.cantidadPlatilloModal,
        id_cuenta_pedido: cuentaAsignada,
        _uid: Math.random().toString(36).substr(2, 9),
        config: {
          ingredientes: this.ingredientesSeleccionados,
          opciones: this.opcionesSeleccionadas,
        },
      });

      this.closeModalConfig();
    },

    aumentarCantidad(i) {
      this.pedido[i].cantidad++;
    },

    disminuirCantidad(i) {
      this.pedido[i].cantidad > 1 ? this.pedido[i].cantidad-- : this.eliminarDelPedido(i);
    },

    eliminarDelPedido(i) {
      this.pedido.splice(i, 1);
    },

    normalizeOpciones(map) {
      const out = [];
      for (const val of Object.values(map || {})) {
        if (!val) continue;
        for (const o of Object.values(val)) {
          if (!o) continue;
          out.push({ ...o, cantidad: o.cantidad || 1 });
        }
      }
      return out;
    },

    async enviarPedido() {
      const sinCuenta = this.pedido.find(p => !p.id_cuenta_pedido);
      if (sinCuenta) {
        this.mostrarAlerta("Debes asignar una cuenta a todos los platillos", "danger");
        return;
      }

      const payload = {
        id_mesa: this.idMesa,
        id_empleado: this.idEmpleado,
        para_llevar: this.paraLlevar,
        notas: this.notasPedido || null,
        detalles: this.pedido.map(p => ({
          id_platillo: p.IdPlatillo,
          id_cuenta_pedido: p.id_cuenta_pedido,
          cantidad: p.cantidad,
          precio_unitario: parseFloat(p.Precio),
          ingredientes: p.config.ingredientes.map(ing => ({
            id_producto: ing.id_producto,
            quitar: ing.quitar,
          })),
          opciones: this.normalizeOpciones(p.config.opciones).map(o => ({
            id_grupo: o.IdGrupoOpcion,
            id_opcion: o.IdOpcion,
            precio_extra: parseFloat(o.PrecioExtra) || 0,
            cantidad: o.cantidad || 1,
          })),
        })),
      };

      if (!payload.detalles.length) {
        this.mostrarAlerta("No puedes enviar un pedido vacío", "danger");
        return;
      }

      try {
        await axios.post(`${API_URL}/pedidos`, payload);
        this.mostrarAlerta("Pedido enviado con éxito", "success");

        this.pedido = [];
        await this.cargarPedidoAbierto();
      } catch (err) {
        if (err.response) {
          this.mostrarAlerta(err.response.data.error || "Error desconocido en el servidor", "danger");
        } else if (err.request) {
          this.mostrarAlerta("No se pudo conectar con el servidor", "danger");
        } else {
          this.mostrarAlerta("Error al enviar el pedido: " + err.message, "danger");
        }
      }
    },

    async confirmarAgregarCuenta() {
      await this.agregarCuenta();
      this.closeModalAgregarCuenta();
    },
    async cargarHabitacionesDisponibles() {
      try {
        const { data } = await axios.get(`${API_URL}/habitaciones-ocupadas-restaurante`);
        // Asegurar que data sea un array
        this.habitacionesDisponibles = Array.isArray(data) ? data : [];
        this.habitacionesFiltradas = this.habitacionesDisponibles;
      } catch (error) {
        console.error('Error cargando habitaciones:', error);
        this.habitacionesDisponibles = [];
        this.habitacionesFiltradas = [];
        this.mostrarAlerta('Error al cargar habitaciones', 'danger');
      }
    },
    filtrarHabitacionesPedido() {
      // Validación: asegurar que habitacionesDisponibles sea un array
      if (!Array.isArray(this.habitacionesDisponibles) || this.habitacionesDisponibles.length === 0) {
        this.habitacionesFiltradas = [];
        return;
      }

      const texto = this.busquedaHabitacion.toLowerCase().trim();
      if (!texto) {
        this.habitacionesFiltradas = [...this.habitacionesDisponibles];
        return;
      }

      try {
        this.habitacionesFiltradas = this.habitacionesDisponibles.filter(h => {
        const numero = (h.Numero || '').toString().toLowerCase();
        const nombre = (h.huesped?.Nombre || '').toLowerCase();
        const apellido = (h.huesped?.Apellido || '').toLowerCase();
        const codigo = (h.CodigoReserva || '').toLowerCase();
        const nombreCompleto = `${nombre} ${apellido}`;
        return (
          numero.includes(texto) ||
          nombreCompleto.includes(texto) ||
          codigo.includes(texto)
        );
        });
      } catch (error) {
        console.error('Error filtrando habitaciones pedido:', error);
        this.habitacionesFiltradas = [];
      }
    },
    async abrirModalAsignarHabitacion(cuenta) {
      this.cuentaSeleccionadaHabitacion = cuenta;
      this.habitacionSeleccionadaCuenta = cuenta.IdReservaHabitacion || null;
      this.busquedaHabitacionCuenta = '';

      // Cargar habitaciones ANTES de mostrar el modal
      this.cargandoHabitaciones = true;
      await this.cargarHabitacionesDisponibles();
      this.habitacionesFiltradasCuenta = Array.isArray(this.habitacionesDisponibles) ? [...this.habitacionesDisponibles] : [];
      this.cargandoHabitaciones = false;

      // Mostrar modal después de cargar los datos
      this.showModalAsignarHabitacion = true;
    },
    cerrarModalAsignarHabitacion() {
      this.showModalAsignarHabitacion = false;
      this.cuentaSeleccionadaHabitacion = null;
      this.habitacionSeleccionadaCuenta = null;
      this.busquedaHabitacionCuenta = '';
      this.habitacionesFiltradasCuenta = [];
    },
    filtrarHabitacionesCuenta() {
      // Validación: asegurar que habitacionesDisponibles sea un array
      if (!Array.isArray(this.habitacionesDisponibles) || this.habitacionesDisponibles.length === 0) {
        this.habitacionesFiltradasCuenta = [];
        return;
      }

      const texto = this.busquedaHabitacionCuenta.toLowerCase().trim();
      if (!texto) {
        this.habitacionesFiltradasCuenta = [...this.habitacionesDisponibles];
        return;
      }

      try {
        this.habitacionesFiltradasCuenta = this.habitacionesDisponibles.filter(h => {
        const numero = (h.Numero || '').toString().toLowerCase();
        const nombre = (h.huesped?.Nombre || '').toLowerCase();
        const apellido = (h.huesped?.Apellido || '').toLowerCase();
        const codigo = (h.CodigoReserva || '').toLowerCase();
        const nombreCompleto = `${nombre} ${apellido}`;
        return (
          numero.includes(texto) ||
          nombreCompleto.includes(texto) ||
          codigo.includes(texto)
        );
        });
      } catch (error) {
        console.error('Error filtrando habitaciones cuenta:', error);
        this.habitacionesFiltradasCuenta = [];
      }
    },
    seleccionarHabitacionParaCuenta(idReservaHabitacion) {
      this.habitacionSeleccionadaCuenta = idReservaHabitacion;
    },
    async confirmarAsignarHabitacion() {
      if (!this.habitacionSeleccionadaCuenta || !this.cuentaSeleccionadaHabitacion) return;

      try {
        await axios.put(
          `${API_URL}/pagar-cuenta-pedido/${this.cuentaSeleccionadaHabitacion.IdCuentaPedido}/cargar-habitacion`,
          { id_reserva_habitacion: this.habitacionSeleccionadaCuenta }
        );
        this.mostrarAlerta('Cuenta asignada a habitación correctamente', 'success');
        this.cerrarModalAsignarHabitacion();
        await this.cargarPedidoAbierto();
      } catch (error) {
        console.error('Error al asignar habitación:', error);
        this.mostrarAlerta('Error al asignar la habitación', 'danger');
      }
    },
    async desasignarHabitacion() {
      if (!this.cuentaSeleccionadaHabitacion) return;

      try {
        await axios.put(
          `${API_URL}/pagar-cuenta-pedido/${this.cuentaSeleccionadaHabitacion.IdCuentaPedido}/cargar-habitacion`,
          { id_reserva_habitacion: null }
        );
        this.mostrarAlerta('Asignación de habitación removida', 'success');
        this.cerrarModalAsignarHabitacion();
        await this.cargarPedidoAbierto();
      } catch (error) {
        console.error('Error al desasignar habitación:', error);
        this.mostrarAlerta('Error al remover la asignación', 'danger');
      }
    },
  },

  mounted() {
    this.idMesa = this.$route.params.idMesa;
    // Establecer el ID del empleado logueado (fallback a 2 si no está disponible)
    this.idEmpleado = this.usuario?.IdEmpleado || 2;
    Promise.all([
      this.cargarMenu(),
      this.obtenerNumeroMesa(),
      this.cargarPedidoAbierto()
    ]);
  }
};
</script>

<style scoped>
/* Animaciones para transiciones */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.toast-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from > div,
.modal-leave-to > div {
  transform: scale(0.9);
}

/* Scroll suave */
html {
  scroll-behavior: smooth;
}

/* Mejoras de scrollbar para Tailwind */
.overflow-y-auto::-webkit-scrollbar {
  width: 8px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  @apply bg-slate-100 dark:bg-slate-800 rounded;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  @apply bg-slate-300 dark:bg-slate-600 rounded;
}

.overflow-y-auto::-webkit-scrollbar-thumb:hover {
  @apply bg-slate-400 dark:bg-slate-500;
}

/* Line clamp utility */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Animación de deslizamiento */
@keyframes slide-in {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.animate-slide-in {
  animation: slide-in 0.3s ease-out;
}

/* Mejoras para tablets - Botones táctiles */
@media (min-width: 768px) {
  button {
    min-height: 44px;
  }

  input,
  select,
  textarea {
    min-height: 48px;
  }
}

/* Transiciones suaves globales */
button,
.transition-colors,
.transition-all {
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  user-select: none;
}

/* Sticky headers optimization */
.sticky {
  position: -webkit-sticky;
  position: sticky;
}

@media (max-width: 1024px) {
  .nuevo-pedido-scroll {
    max-height: 60vh;
    overflow-y: auto;
  }
}
</style>